<template lang="pug">
  .mRow
    .mRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.no-gutters.flex-nowrap.align-items-start
          .mRow__profileImg.mr-3
          .d-flex.align-items-end.flex-nowrap.no-gutters
            .mRow__content.mRow__imgBox.position-relative.d-flex.align-items-center
              .imgBox__insideImgBox
                img(
                  v-lazy="stickerUrl",
                  v-if="hasSticker"
                  style='max-width: 80px;'
                )
                img(
                  v-lazy="defaultStickerImg",
                  v-else-if="!hasSticker"
                )
            .mRow__timeBox
              span(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPreviewImgUrl from '@/assets/images/default/defaultImg404.png';
import defaultStickerImgUrl from '@/assets/images/lineStickers/unupload.png';

import packageIdArray from '@/helper/LineStickers/package/packageId.json';
import stickerIdArray from '@/helper/LineStickers/package/stickerId.json';

export default {
  name: 'M-Sticker',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      defaultPreviewImg: `this.src="${defaultPreviewImgUrl}"`,
      defaultStickerImg: defaultStickerImgUrl,
      packageIdArray,
      stickerIdArray,
      hasSticker: true,
      stickerUrl: null,
    };
  },
  mounted() {
    const vm = this;
    let type = 'IOS';
    // 判斷是否有這個貼圖
    if (vm.packageIdArray.indexOf(parseInt(vm.messageData.package_id)) !== -1 && vm.stickerIdArray.indexOf(parseInt(vm.messageData.sticker_id)) !== -1) {
      vm.hasSticker = true;
    }
    const img = new Image();
    img.onload = function() {
      vm.stickerUrl = `https://stickershop.line-scdn.net/stickershop/v1/sticker/${vm.messageData.sticker_id}/${type}/sticker.png`;
    };
    img.onerror = function() {
      if (type === 'IOS') {
        type = 'ANDROID';
        img.src = `https://stickershop.line-scdn.net/stickershop/v1/sticker/${vm.messageData.sticker_id}/${type}/sticker.png`;
      } else if (type === 'ANDROID') {
        type = 'none';
        vm.stickerUrl = vm.defaultStickerImg;
      }
    };
    img.src = `https://stickershop.line-scdn.net/stickershop/v1/sticker/${vm.messageData.sticker_id}/${type}/sticker.png`;
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
